import { getAccessToken } from '../../Utils/storageUtils';
import pfmClientAxiosInstance from './interceptor';
import { captureException } from '../../Utils/sentryUtils';

export const initiateConsent = async ({
  fipIds,
  templateType,
  consentJourneyType,
  vendor,
}: {
  fipIds: string[];
  templateType: string[];
  consentJourneyType?: string;
  vendor?: string;
}) => {
  try {
    const response = await pfmClientAxiosInstance.post(
      `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/consent/initiate-consent`,
      {
        fipIds: fipIds,
        templateType: templateType,
        consentJourneyType,
        vendor,
      },
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response;
  } catch (e) {
    captureException(e);
    return { data: 'ERROR' };
  }
};
